module.exports = __webpack_public_path__ + "static/media/18.ddc1c500.jpg";